import { nav, language } from '@/stores/action/navigate.action';
import { handleActions } from 'redux-actions';
import { fromJS } from 'immutable';
// import globalNav from 'resources/data/sitemap/global.nav.json';
// import globalTool from 'resources/data/sitemap/global.tool.json';
// import StorageService from 'services/storage.service'
import { getLanguage } from '@/utils/navigator.util';
import { BASE_URL } from '@/constants/myconstants';

// initial state
const initialState = fromJS({
    baseUrl: BASE_URL,
    global: {
        status: { show: [null, null] },
    },
    toolkit: {
        // list: globalTool.list,
    },
    language: {
        // selected: new StorageService().language.get() || 'en',
        selected: getLanguage(),
        options: [],
    },
});

// reducers
const navReducer = handleActions(
    {
        [nav.INITIALIZE]: () => initialState,
        // [nav.GET_NAVIGATE]: (state, action) => {
        //     const { baseUrl, global, toolkit, language } = action.payload
        //     return state.set('baseUrl', fromJS(baseUrl)).setIn(['global', 'list'], fromJS(global)).setIn(['toolkit', 'list'], fromJS(toolkit)).setIn(['language', 'options'], fromJS(language))
        // },
        [nav.SHOW_GLOBAL]: (state, action) => {
            const { depth, index } = action.payload;
            return state.setIn(['global', 'status', 'show', depth - 1], index);
        },
        [language.CHANGE_LANGUAGE]: (state, action) => {
            return state.setIn(['language', 'selected'], fromJS(action.payload));
        },
    },
    initialState,
);

export default navReducer;
